export enum LocationType {
  Office = 'Office',
  Remote = 'Remote',
  BusinessLeave = 'BusinessLeave'
}
